var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("bj-crud-form-modal", {
        ref: "crudModal",
        attrs: {
          model: "Lead",
          "endpoint-edit": "admin/leads",
          fields: _vm.fields,
          "not-crud": ""
        },
        on: { saved: _vm.refreshTable }
      }),
      _c("bj-add-inquiry-modal", {
        ref: "addInquiryModal",
        on: { added: _vm.refreshTable }
      }),
      _c("div", { staticClass: "row full-row-exactly" }, [
        _c(
          "div",
          { staticClass: "col-12 flex-1" },
          [
            _c("bj-data-table", {
              ref: "dataTable",
              attrs: {
                model: "admin/leads",
                "many-name": "Leads",
                "single-name": "Lead",
                title: "",
                "with-cell-delete-button": false,
                "with-cell-edit-button": false,
                "with-total-count": false,
                "with-add-button": false,
                columns: _vm.columns,
                "query-params": _vm.queryParams
              },
              scopedSlots: _vm._u([
                {
                  key: "cell-created_at",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("SdDatetime", { attrs: { value: row.created_at } })
                    ]
                  }
                },
                {
                  key: "cell-full_name",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("SdLeadFullName", { attrs: { lead: row } }),
                      row.notes
                        ? _c("q-icon", {
                            directives: [{ name: "tippy", rawName: "v-tippy" }],
                            staticClass: "ml-2",
                            attrs: {
                              name: "message",
                              size: "14px",
                              title: row.notes
                            }
                          })
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell-inquiries",
                  fn: function(ref) {
                    var row = ref.row
                    return _vm._l(row.inquiries, function(inquiry) {
                      return _c(
                        "q-chip",
                        { key: inquiry.id },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "app.inquiries.timeline",
                                  params: { id: inquiry.id }
                                },
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(inquiry.id) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    })
                  }
                },
                {
                  key: "cell-actions",
                  fn: function(ref) {
                    var row = ref.row
                    return [
                      _c("q-btn", {
                        directives: [{ name: "tippy", rawName: "v-tippy" }],
                        staticClass: "q-ml-sm",
                        attrs: {
                          rounded: "",
                          outline: "",
                          size: "sm",
                          color: "primary",
                          icon: "edit",
                          title: "Edit"
                        },
                        nativeOn: {
                          click: function($event) {
                            var ref
                            ;(ref = _vm.$refs.crudModal).open.apply(
                              ref,
                              ["edit"].concat(row)
                            )
                          }
                        }
                      }),
                      _c("q-btn", {
                        directives: [{ name: "tippy", rawName: "v-tippy" }],
                        staticClass: "q-ml-sm",
                        attrs: {
                          rounded: "",
                          outline: "",
                          size: "sm",
                          color: "green",
                          icon: "add",
                          title: "Add Inquiry"
                        },
                        nativeOn: {
                          click: function($event) {
                            _vm.openInquiryModal(row)
                          }
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }